

























































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class DateRange extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {
    title1: '开始时间',
    title2: '结束时间',
    dateType: '请选择',
    placeholder: '请输入内容',
    required: false,
    autoShowTimeLength: false,
  };

  private options: any = [
    {
      value: '年-月-日',
      label: '年-月-日',
    },
    {
      value: '年-月-日 时:分',
      label: '年-月-日 时:分',
    },
  ];

  // 选项列表
  private optionsList: any = [];

  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }
}
